export const DEMO_PROJECT_ID = '2be4aba5-ac45-45ec-ae26-af536dac6661';
export const TEST_PROJECT_ID = 'd3d05cf2-8547-4246-a74d-daf6c40be198';
export const TEST_ASSET_ID = 'fcdc2ee8-d9d2-41f8-950b-7d85863aea67';
